var formFooterLinksTemplate = require('templates/formFooterLinks.hbs');
var formFooterLinksOrderAwardsTemplate = require('templates/formFooterLinks-orderAwards.hbs');
var formFooterlinksVariation = require('templates/formFooter-linksVariation.hbs');
var AriesComponent = require('libs/aries-component');
var Popup = require('libs/popup');
AriesComponent.create({
    type: 'formFooterLinks',
    template: {
        'formFooterLinks': formFooterLinksTemplate,
        'formFooterLinks-orderAwards': formFooterLinksOrderAwardsTemplate,
        'formFooter-linksVariation': formFooterlinksVariation
    },
    unBindEvents: function($) {
        $('[data-component-id="' + this.$el.data('component-id') + '"] *').off();
    },

    bindEvents: function() {
        'use strict';
        var _self = this;
        _self.footerLinksPopUp();
    },
    footerLinksPopUp: function() {
        if (this.$el.find('.generic-lightbox').length > 0) {
            var genericLightBox = new Popup({
                selector: '.generic-lightbox',
                sourceBlock: '.modal-content',
                alternateCloseMarkup: true
            });
            genericLightBox.register();
        } else {
            var footerLinks = new Popup({
                selector: '.mi-popover.form-footer-links',
                parent: 'formFooterLinks',
                sourceBlock: '.js-popover',
                mainClass: 'm-modal t-modal-med'
            });
            footerLinks.register();
        }
    }
});